var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatDoc = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_131173)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_213_131173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 32H7.79976C5.14879 32 2.99976 29.851 2.99976 27.2V4.8C2.99976 2.14903 5.14879 0 7.79976 0H16.4708C17.7309 0 18.9406 0.495552 19.8385 1.37968L27.5675 8.98974C28.4838 9.89196 28.9998 11.1241 28.9998 12.4101V27.2C28.9998 29.851 26.8507 32 24.1998 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 31.4H7.79976C5.48016 31.4 3.59976 29.5196 3.59976 27.2V4.8C3.59976 2.4804 5.48016 0.6 7.79976 0.6H16.4708C17.5734 0.6 18.6318 1.03361 19.4175 1.80722L27.1465 9.41728C27.9483 10.2067 28.3998 11.2849 28.3998 12.4101V27.2C28.3998 29.5196 26.5194 31.4 24.1998 31.4Z",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 1V7.8C18 9.56731 19.4327 11 21.2 11H28",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_213_131173)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_213_131173",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H24C25.6569 14 27 15.3431 27 17V25C27 26.6569 25.6569 28 24 28H3C1.34315 28 0 26.6569 0 25V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H24C25.6569 14 27 15.3431 27 17V25C27 26.6569 25.6569 28 24 28H3C1.34315 28 0 26.6569 0 25V17Z",
    fill: "#0579D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 17C-0.8 14.9013 0.901318 13.2 3 13.2H24C26.0987 13.2 27.8 14.9013 27.8 17H26.2C26.2 15.785 25.215 14.8 24 14.8H3C1.78497 14.8 0.8 15.785 0.8 17H-0.8ZM27 28H0H27ZM3 28C0.901318 28 -0.8 26.2987 -0.8 24.2V17C-0.8 14.9013 0.901318 13.2 3 13.2V14.8C1.78497 14.8 0.8 15.785 0.8 17V25C0.8 26.6569 1.78497 28 3 28ZM24 13.2C26.0987 13.2 27.8 14.9013 27.8 17V24.2C27.8 26.2987 26.0987 28 24 28C25.215 28 26.2 26.6569 26.2 25V17C26.2 15.785 25.215 14.8 24 14.8V13.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_213_131173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 24H3.63125V17.6H5.84375C6.47917 17.6 7.025 17.7281 7.48125 17.9844C7.93958 18.2385 8.29167 18.6042 8.5375 19.0812C8.78333 19.5583 8.90625 20.1292 8.90625 20.7937C8.90625 21.4604 8.78229 22.0333 8.53438 22.5125C8.28854 22.9917 7.93333 23.3594 7.46875 23.6156C7.00625 23.8719 6.45 24 5.8 24ZM4.79063 22.9969H5.74375C6.18958 22.9969 6.56146 22.9156 6.85938 22.7531C7.15729 22.5885 7.38125 22.3437 7.53125 22.0187C7.68125 21.6917 7.75625 21.2833 7.75625 20.7937C7.75625 20.3042 7.68125 19.8979 7.53125 19.575C7.38125 19.25 7.15938 19.0073 6.86563 18.8469C6.57396 18.6844 6.21146 18.6031 5.77813 18.6031H4.79063V22.9969ZM15.9026 20.8C15.9026 21.4896 15.7734 22.0802 15.5151 22.5719C15.2588 23.0615 14.9088 23.4365 14.4651 23.6969C14.0234 23.9573 13.5224 24.0875 12.9619 24.0875C12.4015 24.0875 11.8994 23.9573 11.4557 23.6969C11.014 23.4344 10.664 23.0583 10.4057 22.5687C10.1494 22.0771 10.0213 21.4875 10.0213 20.8C10.0213 20.1104 10.1494 19.5208 10.4057 19.0312C10.664 18.5396 11.014 18.1635 11.4557 17.9031C11.8994 17.6427 12.4015 17.5125 12.9619 17.5125C13.5224 17.5125 14.0234 17.6427 14.4651 17.9031C14.9088 18.1635 15.2588 18.5396 15.5151 19.0312C15.7734 19.5208 15.9026 20.1104 15.9026 20.8ZM14.7369 20.8C14.7369 20.3146 14.6609 19.9052 14.5088 19.5719C14.3588 19.2365 14.1505 18.9833 13.8838 18.8125C13.6171 18.6396 13.3099 18.5531 12.9619 18.5531C12.614 18.5531 12.3067 18.6396 12.0401 18.8125C11.7734 18.9833 11.564 19.2365 11.4119 19.5719C11.2619 19.9052 11.1869 20.3146 11.1869 20.8C11.1869 21.2854 11.2619 21.6958 11.4119 22.0312C11.564 22.3646 11.7734 22.6177 12.0401 22.7906C12.3067 22.9615 12.614 23.0469 12.9619 23.0469C13.3099 23.0469 13.6171 22.9615 13.8838 22.7906C14.1505 22.6177 14.3588 22.3646 14.5088 22.0312C14.6609 21.6958 14.7369 21.2854 14.7369 20.8ZM22.6528 19.7594H21.484C21.4507 19.5677 21.3892 19.3979 21.2997 19.25C21.2101 19.1 21.0986 18.9729 20.9653 18.8687C20.8319 18.7646 20.6799 18.6865 20.509 18.6344C20.3403 18.5802 20.158 18.5531 19.9622 18.5531C19.6142 18.5531 19.3059 18.6406 19.0372 18.8156C18.7684 18.9885 18.558 19.2427 18.4059 19.5781C18.2538 19.9115 18.1778 20.3187 18.1778 20.8C18.1778 21.2896 18.2538 21.7021 18.4059 22.0375C18.5601 22.3708 18.7705 22.6229 19.0372 22.7937C19.3059 22.9625 19.6132 23.0469 19.959 23.0469C20.1507 23.0469 20.3299 23.0219 20.4965 22.9719C20.6653 22.9198 20.8163 22.8437 20.9497 22.7437C21.0851 22.6437 21.1986 22.5208 21.2903 22.375C21.384 22.2292 21.4486 22.0625 21.484 21.875L22.6528 21.8812C22.609 22.1854 22.5142 22.4708 22.3684 22.7375C22.2247 23.0042 22.0361 23.2396 21.8028 23.4437C21.5694 23.6458 21.2965 23.8042 20.984 23.9187C20.6715 24.0312 20.3247 24.0875 19.9434 24.0875C19.3809 24.0875 18.8788 23.9573 18.4372 23.6969C17.9955 23.4365 17.6476 23.0604 17.3934 22.5687C17.1392 22.0771 17.0122 21.4875 17.0122 20.8C17.0122 20.1104 17.1403 19.5208 17.3965 19.0312C17.6528 18.5396 18.0017 18.1635 18.4434 17.9031C18.8851 17.6427 19.3851 17.5125 19.9434 17.5125C20.2997 17.5125 20.6309 17.5625 20.9372 17.6625C21.2434 17.7625 21.5163 17.9094 21.7559 18.1031C21.9955 18.2948 22.1924 18.5302 22.3465 18.8094C22.5028 19.0865 22.6049 19.4031 22.6528 19.7594Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_213_131173",
    x: 1.39976,
    y: -3.2,
    width: 29.2,
    height: 37.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_213_131173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_213_131173",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_213_131173"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_213_131173",
    x: 0,
    y: 14,
    width: 27,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_213_131173"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_131173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FormatDoc.7e3912f74a726f85df5014ce6544f09a.svg";